var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IImagesRepositoryType } from '../../../Interfaces/IImagesRepository';
import { Observable } from '../../../../Data/Observable/Observable';
import { ImageCacheStrategyDTO } from '../../../DTOs/Application/ImageCacheStrategyDTO';
import { IDebugRepositoryType } from '../IDebugRepository';
import { injectable } from '../../../../Data/Decorators/Injectable';
import { inject } from '../../../../Data/Decorators/Inject';
let DownloadImageUseCase = class DownloadImageUseCase {
    constructor(imagesRepository, debugRepository) {
        this.imagesRepository = imagesRepository;
        this.debugRepository = debugRepository;
        this.isElementVisible = new Observable(false);
    }
    execute(url) {
        var _a;
        if (this.imagesRepository.getIsDownloading(url)) {
            return this.imagesRepository.downloadImage(url);
        }
        (_a = this.promise) === null || _a === void 0 ? void 0 : _a.cancel();
        const strategy = this.imagesRepository.getCacheStrategy().value;
        if (strategy === ImageCacheStrategyDTO.perloadAll) {
            return this.imagesRepository.downloadImage(url);
        }
        if (strategy === ImageCacheStrategyDTO.lazyLoad) {
            if (!this.isElementVisible.value) {
                this.promise = this.isElementVisible.when(val => val);
                return this.promise.then(() => this.imagesRepository.downloadImage(url));
            }
            return this.imagesRepository.downloadImage(url);
        }
        if (Object.values(ImageCacheStrategyDTO).includes(strategy)) {
            this.debugRepository.send({
                type: 'invalid_image_cache_strategy',
                data: { error: `Image cache strategy ${strategy} is registered but not implemented!` }
            });
        }
        else {
            this.debugRepository.send({
                type: 'invalid_image_cache_strategy',
                data: { error: `Image cache strategy ${strategy} not exist!` }
            });
        }
        return this.imagesRepository.downloadImage(url);
    }
    setIsElementVisible(val) {
        return this.isElementVisible.next(val);
    }
    onDestroy() {
        var _a;
        (_a = this.promise) === null || _a === void 0 ? void 0 : _a.cancel();
    }
};
DownloadImageUseCase = __decorate([
    injectable(),
    __param(0, inject(IImagesRepositoryType)),
    __param(1, inject(IDebugRepositoryType)),
    __metadata("design:paramtypes", [Object, Object])
], DownloadImageUseCase);
export { DownloadImageUseCase };
